'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _variants = require('../modules/variants');

var _variants2 = _interopRequireDefault(_variants);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _handlebarsMin = require('handlebars/dist/handlebars.min.js');

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

var _themeCurrency = require('@shopify/theme-currency');

var _handlebarsHelpers = require('../modules/handlebars-helpers');

var _handlebarsHelpers2 = _interopRequireDefault(_handlebarsHelpers);

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/template-collection.scss');

require('../../styles/sections/template-compare.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _handlebarsHelpers2.default)();

exports.default = (0, _themeSections.register)('template-collection', {
  onLoad: function onLoad() {
    var filterButton = document.querySelector('[data-filter-trigger]');
    var triggerClose = document.querySelector('[data-filter-close]');
    var triggerClear = document.querySelector('[data-filter-clear]');
    var triggerMobileFilter = document.querySelector('[data-filter-mobile-trigger]');

    filterButton.addEventListener('click', function (event) {
      (0, _jquery2.default)('[data-filter-options]').slideToggle(200);
      (0, _jquery2.default)(this).addClass('is-active');
    });

    triggerClose.addEventListener('click', function (event) {
      (0, _jquery2.default)('[data-filter-trigger]').trigger('click');
    });

    triggerClear.addEventListener('click', function (event) {
      clearAllFilterOptions(event);
    });

    triggerMobileFilter.addEventListener('click', function (event) {
      setTimeout(function () {
        (0, _jquery2.default)('[data-filter-options]').slideToggle(200);
      }, 400);
    });

    // Compare products
    var updateComparedProducts = function () {
      var compareTemplate = document.querySelector('#CompareProductsTemplate');
      var compareContainer = document.querySelector('#CompareProductsContainer');
      var compareTemplateHandlebars = _handlebarsMin2.default.compile(compareTemplate.innerHTML);

      if (compareContainer) {
        console.log(this.compared);
        compareContainer.innerHTML = compareTemplateHandlebars(this.compared);
        var compareRemoves = compareContainer.querySelectorAll('[data-compare-remove]');

        // Attach remove events
        compareRemoves.forEach(function (remove, index) {
          remove.addEventListener('click', function (event) {
            event.preventDefault();
            var product = remove.dataset.compareRemove;

            // Delete from the object
            if (this.compared.items.hasOwnProperty(product)) {
              delete this.compared.items[product];
              (0, _jquery2.default)('#compare_' + product).trigger('click');
            } else {
              console.warn('Item ' + product + ' not found');
            }

            // Update the saved items
            _jsCookie2.default.set('compared', this.compared);

            // Update the currently compared product previews
            updateComparedProducts();
          }.bind(this));
        }.bind(this));
      }
    }.bind(this);

    var initCompareProducts = function () {
      var compareTriggers = this.container.querySelectorAll('[data-compare-product]');

      this.compareLimit = 4;
      this.currentCollection = JSON.parse(this.container.dataset.collectionId);
      this.defaultCompare = {
        collection: this.currentCollection,
        items: {}
      };

      this.compared = _jsCookie2.default.getJSON('compared') || this.defaultCompare;

      // Check selected products if we are on the correct collection
      if (this.compared.collection == this.currentCollection) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.keys(this.compared.items)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var trigger = this.container.querySelector('[data-compare-product="' + key + '"]');

            if (trigger) {
              trigger.checked = true;
            }
          }

          // Display the currently compared product previews
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        updateComparedProducts();
      }

      if (compareTriggers) {
        compareTriggers.forEach(function (trigger, index) {
          if (!trigger.classList.contains('compare-initialised')) {
            trigger.addEventListener('change', function (event) {
              var target = event.target.dataset;
              var product = JSON.parse(target.compareProduct);
              var variant = JSON.parse(target.compareVariant);

              // Reset compared items if we are on a new collection
              if (this.compared.collection != this.currentCollection) {
                this.compared = this.defaultCompare;
              }

              if (event.target.checked) {
                this.compared.items[product] = {
                  variant: variant

                  // Grab additional data for the preview
                };var collectionProduct = this.container.querySelector('[data-collection-product="' + product + '"]');
                if (collectionProduct) {
                  var productJSON = JSON.parse(collectionProduct.querySelector('[data-product-json]').innerHTML);
                  var currentVariant = {};

                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = Object.keys(productJSON.variants)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var _key = _step2.value;

                      var variantJSON = productJSON.variants[_key];
                      if (variantJSON.id == variant) {
                        currentVariant = variantJSON;
                        break;
                      }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }

                  var previewData = {
                    title: productJSON.title,
                    id: product,
                    handle: productJSON.handle,
                    images: productJSON.images,
                    price: currentVariant.price,
                    rating: null
                  };

                  this.compared.items[product].product = previewData;
                }
              } else {
                if (this.compared.items.hasOwnProperty(product)) {
                  delete this.compared.items[product];
                }
              }

              // Limit compared items to the specified amount
              var items = Object.keys(this.compared.items);

              if (items.length > this.compareLimit) {
                var remaining = items.length - this.compareLimit;
                var _index = 0;

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _key2 = _step3.value;

                    if (_index < remaining) {
                      delete this.compared.items[_key2];
                      var itemTrigger = this.container.querySelector('[data-compare-product="' + _key2 + '"]');

                      if (itemTrigger) {
                        if (itemTrigger.checked) {
                          itemTrigger.checked = false;
                        }
                      }
                    }

                    _index++;
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }

              // Update saved items
              _jsCookie2.default.set('compared', this.compared);
              // Display the currently compared product previews
              updateComparedProducts();
            }.bind(this));
            trigger.classList.add('compare-initialised');
          }
        }.bind(this));
      }
    }.bind(this);

    // Product variant switching
    var products = {};

    var selectors = {
      addToCart: '[data-add-to-cart-button]',
      addToCartText: '[data-add-to-cart-text]',
      comparePrice: '[data-compare-price]',
      comparePriceText: '[data-compare-text]',
      collectionProducts: '[data-collection-product]',
      originalSelectorId: '[data-product-select]',
      productJson: '[data-product-json]',
      productPrice: '[data-product-price]',
      singleOptionSelector: '[data-single-option-selector]',
      errorBox: '[data-error]',
      productId: '[data-add-product]'
    };

    var initVariants = function initVariants() {
      var collectionProducts = document.querySelectorAll(selectors.collectionProducts);
      collectionProducts.forEach(function (product, index) {
        if (!product.classList.contains('variants-initialised')) {
          var id = product.dataset.collectionProduct;
          var jason = JSON.parse(product.querySelector(selectors.productJson).innerHTML);
          var $container = (0, _jquery2.default)(product);
          var options = {
            $container: $container,
            enableHistoryState: false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: jason
          };

          product.classList.add('variants-initialised');

          products[id] = {
            json: jason,
            variants: new _variants2.default(options),
            container: $container
          };

          $container.on('variantChange', function (event) {
            updateProductVariant(event, $container);
          });

          $container.on('variantPriceChange', function (event) {
            updateProductPrices(event, $container);
          });
        }
      });

      initCompareProducts();
    };

    /**
     * Updates the DOM with the correct quick-add variant id & button state
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    var updateProductVariant = function (event, $container) {
      var variant = event.variant;

      if (variant !== null) {
        (0, _jquery2.default)(selectors.addToCart, $container).attr('data-quick-add', variant.id);
        (0, _jquery2.default)('[data-compare-product]', $container).attr('data-compare-variant', variant.id);
        (0, _jquery2.default)('[data-add-product]', $container).addClass('hide');
        (0, _jquery2.default)('[data-quick-add="' + variant.id + '"]:not([data-add-product])', $container).removeClass('hide');
        (0, _jquery2.default)('[data-error]', $container).addClass('hide');

        if (variant.available) {
          (0, _jquery2.default)(selectors.addToCart, $container).prop('disabled', false);
          (0, _jquery2.default)(selectors.addToCartText, $container).html(theme.strings.addToCart);
        } else {
          (0, _jquery2.default)(selectors.addToCart, $container).prop('disabled', true);
          (0, _jquery2.default)(selectors.addToCartText, $container).html(theme.strings.soldOut);
        }

        // Update any relevant compared variants
        var product = $container[0].dataset.collectionProduct;
        var keys = Object.keys(this.compared.items);
        if (keys.indexOf(product) > -1) {
          var itemTrigger = $container[0].querySelector('[data-compare-product="' + product + '"]');
          itemTrigger.checked = true;
          itemTrigger.dispatchEvent(new Event('change'));
        }
      } else {
        (0, _jquery2.default)(selectors.addToCart, $container).attr('data-quick-add', '').prop('disabled', true);
      }
    }.bind(this);

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    var updateProductPrices = function updateProductPrices(event, $container) {
      var variant = event.variant;
      var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, $container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, $container);

      (0, _jquery2.default)(selectors.productPrice, $container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      var currencyTrigger = new Event('currency:convert');
      document.dispatchEvent(currencyTrigger);
    };

    document.addEventListener('collection:productsAdded', initVariants);
    initVariants();
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});